import { SINATRA_LOGOUT } from '@rsos/sinatra';
import {
  FORCED_LOGOUT_SUCCESS,
  LOGOUT_SUCCESS,
  REMOVE_MA,
  SET_CANDIDATES,
  SET_CURRENT_MAFID,
  SET_MA_LOADING_STATE,
  SET_MAFID_TO_QUERY,
  SET_PROFILE,
} from '../actions/actionTypes';

const initialState = {
  candidates: [],
  currentMafid: null,
  loadingMa: false,
  mafidToQuery: null, // use for search? since currentMafid can be used from query by phone
  profiles: {},
};

const medicalert = (state = initialState, action) => {
  switch (action.type) {
    case FORCED_LOGOUT_SUCCESS:
    case LOGOUT_SUCCESS:
    case SINATRA_LOGOUT:
    case REMOVE_MA:
      return initialState;
    case SET_CANDIDATES:
      return {
        ...state,
        candidates: action.candidates,
      };
    case SET_CURRENT_MAFID:
      return {
        ...state,
        currentMafid: action.mafid,
        // If profile is already in state, no need for loading state
      };
    case SET_MA_LOADING_STATE:
      return {
        ...state,
        loadingMa: action.bool,
      };
    case SET_MAFID_TO_QUERY:
      return {
        ...state,
        mafidToQuery: action.mafid,
      };
    case SET_PROFILE:
      return {
        ...state,
        profiles: {
          ...state.profiles,
          [action.mafid]: action.profile,
        },
      };
    default:
      return state;
  }
};

export default medicalert;
